module.exports = __webpack_public_path__ + "img/thompson-logo.dc11085a.jpg";